import { TopErrorBoundary } from '@cdk-prod/fortellis-radial-error-boundary';
import { connect } from 'react-redux';

export default connect(({ loginDetailsSlice }) => ({
    auth: {
        accessToken: loginDetailsSlice.authenticationToken,
        // there is no such thing as a fortellis user id for DP users.
        // the equivalent field in the token contains the user's email
        userId: loginDetailsSlice.userEmail,
        userEmail: loginDetailsSlice.userEmail
    }
}))(TopErrorBoundary)
